import { useState } from "react"
import { Alert, Box, Button, FormControlLabel, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material"
import { Switch, Case } from "lib/@components/switch"
import { setFromValueParam } from "lib/setFromEvent"

const STATE_LABEL = { live: "Live", candidate: "Candidate", draft: "Draft" }

export function PromoteScenarioDialog({ ok, cancel, scenario, variant }) {
    const [mode, setMode] = useState("new")
    const [name, setName] = useState("")
    const sourceLabel = STATE_LABEL[detectState(scenario?.regimeId)] ?? "Draft"
    const regimeName = scenario?.regimeName ?? "the regime"

    return (
        <Stack spacing={3} sx={{ p: 3, minWidth: 460 }}>
            <Box>
                <Typography variant="h6">Promote Scenario</Typography>
                <Typography variant="body2" color="text.secondary">
                    Applies variant <strong>{variant?.name}</strong>&apos;s rules as schedule tailorings. Each change
                    keeps its rule&apos;s justification.
                </Typography>
            </Box>

            <RadioGroup value={mode} onChange={setFromValueParam(setMode)}>
                <FormControlLabel
                    value="new"
                    data-cy="promote-mode-new"
                    control={<Radio />}
                    label="Create a new draft regime"
                />
                <FormControlLabel
                    value="existing"
                    data-cy="promote-mode-existing"
                    control={<Radio />}
                    label="Update this regime's draft"
                />
            </RadioGroup>

            <Switch value={mode}>
                <Case when="new">
                    <Stack spacing={3}>
                        <Typography variant="body2" color="text.secondary">
                            Creates a new draft regime by copying <strong>{regimeName}</strong> ({sourceLabel}).
                        </Typography>
                        <TextField
                            label="New regime name (optional)"
                            value={name}
                            onChange={handleNameChange}
                            placeholder={`${scenario?.regimeName ?? "Regime"} — ${variant?.name ?? "variant"}`}
                            data-cy="promote-name"
                            fullWidth
                        />
                    </Stack>
                </Case>
                <Case when="existing">
                    <Alert severity="warning" data-cy="promote-existing-warning">
                        Resets <strong>{regimeName}</strong>&apos;s draft to its {sourceLabel} version and applies these
                        rules. Any unsaved changes in the current draft will be replaced.
                    </Alert>
                </Case>
            </Switch>

            <Stack direction="row" spacing={2} justifyContent="flex-end">
                <Button onClick={handleCancel}>Cancel</Button>
                <Button data-cy="promote-submit" variant="contained" onClick={handleSubmit}>
                    Promote
                </Button>
            </Stack>
        </Stack>
    )

    function handleNameChange(e) {
        setName(e.target.value)
    }

    function handleCancel() {
        cancel()
    }

    function handleSubmit() {
        ok({
            variantId: variant?.id,
            newName: mode === "new" ? name.trim() || undefined : undefined,
            mode,
        })
    }
}

function detectState(regimeId) {
    if (regimeId?.startsWith("live|")) return "live"
    if (regimeId?.startsWith("ready|")) return "candidate"
    return "draft"
}
